import DBOperationsComb from "src/utils/dbOperationsComb";
import Exception from "src/utils/exception";

async function getPlantLocationList(tableName, config) {
  try {
    return await DBOperationsComb.fetchData(
      {
        tableName,
        fetchDeleted: config.fetchDeleted,
        searchTxt: config.searchTxt,
        sortField: config.sortField,
        sortOrder: config.sortOrder,
        page: config.page,
        rows: config.rows,
        fetchAll: config.fetchAll,
        queryParams: config.queryParams
      },
      false
    );
  } catch (error) {
    Exception.catchException(error);
    return null;
  }
}

export default {
  getPlantLocationList
};
